import { i18n } from 'utils/i18n';

export const PRODUCTS_NOT_DUPLICATED = {
  label: i18n.t('frontproductstream.constants.duplicated_products.no', {
    defaultValue: 'No',
  }),
  id: false,
};
